// Interface for the entry (employeePhotoInfo or staffPhotoInfo item)
export interface PhotoEntry {
    webLocationIds?: number[];
    franchiseProfileEmployeeBioDetail?: {
        franchiseProfileEmployeeBioDetailsId?: number;
        franchiseProfileEmployeeBioId?: number;
        preferredPhotoType?: string | null;
        squarePhotoUrl?: string | null;
        circularPhotoUrl?: string | null;
        photoExtension?: string | null;
        altTag?: string | null;
        title?: string | null;
        lastName?: string | null;
        firstName?: string | null;
        name?: string | null;
        yearHired?: number | null;
        yearsExpierenceDateOfHire?: string | null;
        genderTypeId?: number | null;
        gender?: string | null;
        maritalStatus?: string | null;
        numberOfChildren?: number | null;
        city?: string | null;
        state?: string | null;
        createDateTime?: string;
        updateDateTime?: string;
        deletedDateTime?: string | null;
        franchiseProfileEmployeeBioVariableId?: number | null;
        displayName?: string | null;
    };
    franchiseProfileEmployeeBioId?: number;
    franchiseId?: number;
    aspNetUserId?: string;
    createdDateTime?: string;
    createdUser?: string;
    updatedDateTime?: string;
    updatedUser?: string;
    deletedDateTime?: string | null;
    displayName?: string | null;
    description?: string | null;
    webImageId?: number | null;
    // You may add other properties used in staffPhotoInfo objects as needed.
    title?: string | null;
    name?: string | null;
}

// Interface for the top-level JSON object
export interface TeamJson {
    franchiseWebLocationIds: number[];
    teamSize: number;
    photoType: string;
    teamInfo: any;          // You can further specify the type if known
    staffPhotoInfo: PhotoEntry[];
    employeePhotoInfo: PhotoEntry[];
}

// Define a function to check for valid entry
function isValidEntry(entry:PhotoEntry):boolean {
    if (!entry) return false;
    // Try to get title, name, displayName from top-level or nested franchiseProfileEmployeeBioDetail
    let title = entry.title;
    let name = entry.name;
    let displayName = entry.displayName;

    // Check nested franchiseProfileEmployeeBioDetail if exists
    if (entry.franchiseProfileEmployeeBioDetail) {
        title = title || entry.franchiseProfileEmployeeBioDetail.title;
        name = name || entry.franchiseProfileEmployeeBioDetail.name;
        displayName = displayName || entry.franchiseProfileEmployeeBioDetail.displayName;
    }

    // Check if at least one of them exists and is not empty
    return !!(title?.trim() || name?.trim() || displayName?.trim());
}

export function isValidTeamJson(json:TeamJson):boolean {
    // teamInfo exists and is not null
    const hasTeamInfo = json.teamInfo !== null && json.teamInfo !== undefined;
    const hasValidTeamSize = typeof json.teamSize === 'number' && json.teamSize > 0;

    if(hasTeamInfo && hasValidTeamSize) return true;

    // If team info or team size is not correctly authored in API response, we look at other data

    // staffPhotoInfo or employeePhotoInfo exists (not null or undefined)
    const hasPhotoInfo = (json.staffPhotoInfo && Array.isArray(json.staffPhotoInfo)) ||
                         (json.employeePhotoInfo && Array.isArray(json.employeePhotoInfo));

    // Check for valid entries in staffPhotoInfo and employeePhotoInfo
    const validStaffPhotoEntry = Array.isArray(json.staffPhotoInfo) && json.staffPhotoInfo.some(isValidEntry);
    const validEmployeePhotoEntry = Array.isArray(json.employeePhotoInfo) && json.employeePhotoInfo.some(isValidEntry);
    const hasValidPhotoEntry = validStaffPhotoEntry || validEmployeePhotoEntry;

    // Combine all checks
    return !!(hasPhotoInfo && hasValidPhotoEntry);
}